<template>
  <div class="productCard">
    <img :src="product.img" />
    <div id="title">
      <h4>{{ product.class }}</h4>
      <h5>{{ product.price }}</h5>
    </div>
    <p>{{ product.text }}</p>
    <div id="buttons">
      <button id="findMore" v-on:click="findMoreClick(product)">
        Find More &nbsp;>
      </button>
      <button id="buyNow" v-on:click="findMoreClick(product)">Buy Now</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "productCard",
  props: ["product"],
  data() {
    return {};
  },
  methods: {
    findMoreClick(productSelected) {
      this.$router.push("/productDetail/" + productSelected.id);
    }
  }
};
</script>
<style lang="scss" scoped>
.productCard {
  min-width: 80%;
  width: 80%;
  @include media-md {
    min-width: 300px;
    width: 300px;
  }
  margin: 1.5rem;
  @include media-md {
    margin: 2rem;
  }
  img {
    width: 100%;
    height: auto;
  }
  #title,
  #buttons {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-top: 0;
    margin-top: 0;
  }
  #title {
    padding: 0;
    margin: 0;
    height: 25px;
    h4,
    h5 {
      margin: 0;
      padding: 0;
    }
  }
  p {
    padding: 5px 0;
    margin: 5px 0;
  }
  #findMore {
    color: $color1;
    background-color: $white;
    border: 1px solid $color1;
  }
}
</style>

